import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const PlayIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "",
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
    >
      <title>Play</title>
      <path
        d="m35.011 21.54-24.03 13.68c-1.052.527-2.104.176-2.806-.701 0-.35-.175-.702-.175-1.052V6.105C8 4.877 8.877 4 9.93 4c.35 0 .701.175 1.052.35l24.03 13.682c1.051.526 1.227 1.754.7 2.806-.175.35-.35.526-.7.702Z"
        fill={fill}
      />
    </svg>
  );
};

export default PlayIcon;
